export default __webpack_public_path__ + "media/images/favicon/mstile-150-360586cc4146b5f548253a7bbbe48289.png";